<template>
  <div class="layout-exam">
    <Header :fullHeader="false" :containerFluid="true"></Header>

    <b-container fluid>
      <b-row>
        <main class="col-md-12 py-3 px-4">
          <router-view />
        </main>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import Header from "@/components/Header";
// import Sidebar from "@/components/dashboard/Sidebar";

export default {
  components: {
    Header,
    // Sidebar
  },
  computed: {
    error() {
      return this.$store.getters.error
    }
  },
  watch: {
    error(fbError) {
      this.$toast(fbError || 'Что-то пошло не так', {title: 'Ошибка', variant: 'warning'})
    }
  },
  async mounted() {
    try {
      await this.$store.dispatch('userData')
    } catch(e) {
      //  
    }
     console.log('mounted')
  }
};
</script>

<style lang="scss">
@import "@/assets/styles/modules/layout-exam";
</style>
